var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index-news-imgBanner"},[_c('el-carousel',{attrs:{"height":"270px"}},_vm._l((_vm.dataList),function(item,index){return (index<5)?_c('el-carousel-item',{key:index},[_c('img',{attrs:{"src":item.contentImg}})]):_vm._e()}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }